module.exports = __webpack_public_path__ + "static/media/doublecheck.dc9d2826.svg";